import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of the provided value.
 * The returned value only updates after the given delay without changes.
 */
export default function useDebouncedValue(value, delay = 400) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebouncedValue(value), delay);
    return () => {
      clearTimeout(handle);
    };
  }, [value, delay]);

  return debouncedValue;
}
